var React = require('react');

function AttrInt (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:none;stroke:#000000;stroke-width:6;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n"),React.createElement("g",{"key":1},[React.createElement("path",{"d":"M14,20c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S17.3,20,14,20z M14,10c-2.2,0-4,1.8-4,4s1.8,4,4,4s4-1.8,4-4S16.2,10,14,10z","key":0}),React.createElement("path",{"d":"M14,23.7c-6.1,0-11.6-3.6-13.9-9.3L-0.1,14l0.2-0.4C2.4,8,7.9,4.3,14,4.3S25.6,8,27.9,13.6l0.2,0.4l-0.2,0.4\n\t\tC25.6,20,20.1,23.7,14,23.7z M2.1,14c2.1,4.7,6.8,7.7,11.9,7.7s9.8-3,11.9-7.7C23.8,9.3,19.2,6.3,14,6.3S4.2,9.3,2.1,14z","key":1})])]);
}

AttrInt.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 28 28","style":{"enableBackground":"new 0 0 28 28"},"xmlSpace":"preserve"};

module.exports = AttrInt;

AttrInt.default = AttrInt;
